const getEnvironmentConfig = () => {
  const env = process.env.REACT_APP_NODE_ENV || "development"; // Default to 'development'
  console.log("env: ", process.env);

  const currentHost = window.location.origin; 
  console.log("currentHost:", currentHost);

  const configs = {
    development: {
      baseURL:
        process.env.REACT_APP_VIBER_APP_API_BASE_URL_DEV || currentHost,
    },
    test: {
      baseURL:
        process.env.REACT_APP_VIBER_APP_API_BASE_URL_TEST || currentHost,
    },
    production: {
      baseURL:
        process.env.REACT_APP_VIBER_APP_API_BASE_URL_PROD || currentHost,
    },
  };

  let config = configs[env] || configs.development;
  config.env = env;

  console.log("config:", config);

  return config; // Fallback to 'development' if no match
};

const environmentConfig = getEnvironmentConfig();

const apiConfig = {
  companyName: process.env.REACT_APP_IBER_APP_COMPANY_NAME || "Appistoki India Pvt Ltd.",
  version: process.env.REACT_APP_VIBER_APP_VERSION || '1.0.0',
  baseURL: environmentConfig.baseURL,
  endpoints: {
    auth: {
      login: "/api/auth/login",
    },
    customers: {
      base: "/api/customers",
      paginated: "/api/customers",
      byId: (id) => `/api/customers/${id}`,
    },
    messagingApiConfig: {
      base: "/api/messaging-configs",
      paginated: "/api/messaging-configs",
      byId: (id) => `/api/messaging-configs/${id}`,
    },
    salesforceConfig: {
      base: "/api/salesforce-configs",
      paginated: "/api/salesforce-configs",
      byId: (id) => `/api/salesforce-configs/${id}`,
    },
    requestLogs: {
      base: "/api/request-logs",
      paginated: "/api/request-logs"
    },
    users: {
      base: "/api/users",
      paginated: "/api/users",
      byId: (id) => `/api/users/${id}`,
      resetPassword: (id) => `/api/users/${id}/reset-password`,
    },
    rateLimit: {
      getConfig: "/api/config/rate-limit",
      updateConfig: "/api/config/rate-limit"
    },
    dashboard: {
      metrics: "/api/dashboard/metrics",
      statusDistribution: "/api/dashboard/status-distribution",
      requestsOverTime: "/api/dashboard/requests-over-time",
      responseTimeAnalysis: "/api/dashboard/response-time-analysis",
      errorRateAnalysis: "/api/dashboard/error-rate-analysis",
      systemHealth: "/api/dashboard/system-health",
      all: "/api/dashboard/all"
    },
    queue: {
      status: "/api/queue/status"
    },
    worker: {
      base: "/api/worker",
      stats: "/api/worker/stats",
      max: "/api/worker/max",
      byId: (id) => `/api/worker/${id}`,
      reprocessFailed: "/api/worker/reprocess-failed",
      cleanup: "/api/worker/cleanup",
      queueDetails: "/api/worker/queue/details"
    }
  },
  rowsPerPageOptions: [10, 25, 50, 100],
};

export default apiConfig;